import * as React from 'react';
import { useStyles } from '@sravni/react-utils';
import { CONTENT_SIZES } from '../../../constants/sizes.js';
import modules_436816d0 from '../styles/Spinner.module.less.js';

/**
 * @description A spinner for displaying loading state of a page or a section
 *
 * @component
 * @example
 * ```jsx
 * <Spinner />
 * ```
 */
const Spinner = React.forwardRef((props, ref) => {
    const { size, className, ...restProps } = props;
    const cx = useStyles(modules_436816d0);
    const classNames = cx(className, 'container', {
        [`size-${size}`]: size,
    });
    return (React.createElement("span", { ref: ref, "data-qa": "Spinner", className: classNames, ...restProps },
        React.createElement("svg", { className: cx('svg'), viewBox: "0 0 150 150" },
            React.createElement("circle", { className: cx('circle', 'circle-1'), cx: "75", cy: "75", r: "60" }),
            React.createElement("circle", { className: cx('circle', 'circle-2'), cx: "75", cy: "75", r: "60" }))));
});
Spinner.defaultProps = {
    size: CONTENT_SIZES.S20,
};
Spinner.displayName = 'Spinner';

export { Spinner };
//# sourceMappingURL=Spinner.js.map
